// client/RenderableConfigFormController.ts
import { nothingHere } from "@adornis/base/change.js";
import { GenericFieldFormController } from "@adornis/cms/client/generic-field-formcontroller.js";
var RenderableConfigFormController = class extends GenericFieldFormController {
  constructor(host, document, size, defaultValues = {}, options = {}) {
    super(host, document, options);
    this.defaultValues = {};
    this._size = size;
    this._onValueChanged = options.onValueChanged;
    this.defaultValues = defaultValues;
  }
  async _handleValueChanged(keys, formField, value) {
    try {
      await this.validator.validatePath(this.document || {}, keys, {
        ...this._defaultValidationMeta,
        ...this.options.validationMeta?.()
      });
      formField.error = void 0;
      const resolvedValue = this.document?.value(keys, this._size);
      if (resolvedValue !== value)
        this._setHasChanged(true);
    } catch {
    }
  }
  registerDefaults(defaultValues = {}, path = []) {
    const instance = this.document;
    if (!instance)
      return;
    const key = path.join(".");
    const currentDefaults = this.defaultValues[key];
    const newDefaults = { ...currentDefaults };
    for (const [key2, value] of Object.entries(defaultValues)) {
      newDefaults[key2] = typeof value === "function" ? value(instance) : value;
    }
    this.defaultValues[key] = newDefaults;
    this._setFieldsFromDocument();
  }
  async _applySingleChange(keys, value, validationMeta, validate) {
    this.document?.setValue(keys, value, this._size);
    this._onValueChanged?.();
  }
  _setFieldsFromDocument() {
    Array.from(this.formFields.entries()).forEach(([keyString, formFields]) => {
      const allKeys = keyString.split(".");
      const key = allKeys[allKeys.length - 1];
      const path = allKeys.slice(0, allKeys.length - 1);
      const defaultValue = this.defaultValues[path.join(".")]?.[key] ?? void 0;
      let value = this.document?.value(allKeys, this._size);
      if (typeof value !== "boolean" && !value && defaultValue) {
        const defvalue = this._size && (defaultValue[this._size] || typeof defaultValue[this._size] === "boolean") ? defaultValue[this._size] : defaultValue.global;
        if (defvalue || typeof defvalue === "boolean")
          value = defvalue;
      }
      if (value === nothingHere)
        return;
      formFields.forEach((formField) => {
        if (formField.field.value.value !== value)
          formField.field.value.next(value);
      });
    });
  }
  // @ts-ignore typescript doesn't let you override this method
  field(...keys) {
    return super.field(...keys);
  }
  get size() {
    return this._size;
  }
};
export {
  RenderableConfigFormController
};
